import React, { useState, useEffect } from 'react';
import authService from '../../api-authorization/AuthorizeService';
import axios from 'axios';
import SupportUs from '../supporters/SupportUs';
import PGNViewer from '../../PGNViewer';
import GameById from './GameById'
import { Switch, Checkbox, Button, TextField, Modal, Box, Grid, Stack, Typography, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormGroup, FormControl, FormLabel, FormControlLabel, Accordion, AccordionSummary, AccordionDetails } from '@mui/material'
import LoadingButton from '@mui/lab/LoadingButton';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormHelperText from '@mui/material/FormHelperText';
import Select, { SelectChangeEvent } from '@mui/material/Select';

export default function EditGameById(props) {
    const [gameId, setGameId] = useState(props.gameId ? props.gameId : (props.match.params.gameId ? props.match.params.gameId : ""));
    const [event, setEvent] = useState();
    const [site, setSite] = useState();
    const [date, setDate] = useState();
    const [white, setWhite] = useState();
    const [whiteElo, setWhiteElo] = useState();
    const [whiteFIDEID, setWhiteFIDEID] = useState();
    const [whiteUSCFID, setWhiteUSCFID] = useState();
    const [whiteCFCID, setWhiteCFCID] = useState();
    const [black, setBlack] = useState();
    const [blackElo, setBlackElo] = useState();
    const [blackFIDEID, setBlackFIDEID] = useState();
    const [blackUSCFID, setBlackUSCFID] = useState();
    const [blackCFCID, setBlackCFCID] = useState();
    const [result, setResult] = useState();
    const [uscfEventId, setUSCFEventId] = useState();
    const [fideEventId, setFIDEEventId] = useState();
    const [errorMessage, setErrorMessage] = useState();
    const [game, setGame] = useState();
    const [membershipLevel, setMembershipLevel] = useState(0);
    const [round, setRound] = useState();
    const [year, setYear] = useState();
    const [month, setMonth] = useState();
    const [day, setDay] = useState();
    const [downloading, setDownloading] = useState(false);
    const [statusColor, setStatusColor] = useState();
    const [status, setStatus] = useState();
    const [updateTime, setUpdateTime] = useState();

    const membershipLevelNames = ['MembershipLevel.Basic', 'MembershipLevel.Bronze', 'MembershipLevel.Silver', 'MembershipLevel.Gold', 'MembershipLevel.Diamond', 'MembershipLevel.L5', 'MembershipLevel.L6', 'MembershipLevel.L7', 'MembershipLevel.L8', 'MembershipLevel.VIP'];


    useEffect(async () => {
        var t = await authService.getAccessToken();
        var headers = {
            headers: { 'Authorization': `Bearer ${t}` }
        }
        try {
            const res = await axios.get('/api/chessgames/' + gameId, headers);
            const g = res.data;
            setGame(g);
            setEvent(g.event);
            setSite(g.site);
            setResult(g.result);
            setRound(g.round);
            setYear(g.year);
            setMonth(g.month);
            setDay(g.day);
            setUSCFEventId(g.uscfEventId);
            setFIDEEventId(g.fideEventId);
            setMembershipLevel(g.membershipLevel);
            setWhite(g.white);
            setWhiteFIDEID(g.whiteFIDEID);
            setWhiteUSCFID(g.whiteUSCFID);
            setWhiteCFCID(g.whiteCFCID);
            setWhiteElo(g.whiteElo);
            setBlack(g.black);
            setBlackFIDEID(g.blackFIDEID);
            setBlackUSCFID(g.blackUSCFID);
            setBlackCFCID(g.blackCFCID);
            setBlackElo(g.blackElo);
            setUpdateTime(g.importTime);
        }
        catch (error) {
            console.log(JSON.stringify(error));
            setErrorMessage(error.response.data);
        };
    }, []); 

    const updateChessGame = async () => {
        //e.preventDefault();

        const data = JSON.stringify(
            {
                gameHash: gameId,
                pgnString: game.pgnString,
                event: event,
                site: site,
                result:result,
                round:round,
                year:year,
                month:month,
                day:day,
                uscfEventId:uscfEventId,
                fideEventId:fideEventId,
                //membershipLevel: membershipLevelNames[membershipLevel],
                membershipLevel: membershipLevel,
                white: white,
                whiteFIDEID: whiteFIDEID,
                whiteUSCFID:whiteUSCFID,
                whiteCFCID:whiteCFCID,
                whiteElo:whiteElo,
                black:black,
                blackFIDEID: blackFIDEID,
                blackUSCFID: blackUSCFID,
                blackCFCID: blackCFCID,
                blackElo:blackElo
                }
        );


        var t = await authService.getAccessToken();
        var headers = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${t}`
            }
        }
        //var body = {

        //    }
        //trackPromise(
            axios.patch('/api/chessgames/' + gameId, data, headers).then((response) => {
                let newGame = response.data;
                setDownloading(false);
                setStatusColor("green");
                setStatus("Game updated successfully");
                setUpdateTime(new Date());
            }).catch((error) => {
                setDownloading(false);
                setStatus(JSON.stringify(error));
                setStatusColor("red");
                console.log(error.response.data);
            })
        //)

    };

    return (
        <div>
        <Grid container direction="row" rowSpacing={1} columnSpacing={1} justify-content="space-between" align-items="stretch">
                            <Grid item xs={6} lg={3}>
                                <Stack>
                                    <TextField
                                        required
                                        fullwidth="true"
                                        size="small"
                                        label={'Event Name'}
                                        InputLabelProps={{ shrink: true, }}
                                        variant='outlined'
                                        value={event}
                                        onChange={async (e) => { setEvent(e.target.value) }}
                                    />
                                </Stack>
                            </Grid>
                            <Grid item xs={6} lg={2}>
                                <Stack>
                                    <TextField
                                        required
                                        fullwidth="true"
                                        size="small"
                                        label={'Site'}
                                        InputLabelProps={{ shrink: true, }}
                                        variant='outlined'
                                        value={site}
                                        onChange={async (e) => { setSite(e.target.value) }}
                                    />
                                </Stack>
                            </Grid>
                            <Grid item xs={6} lg={1}>
                                <Stack>
                                    <TextField
                                        required
                                        fullwidth="true"
                                        size="small"
                                        label={'Round'}
                                        InputLabelProps={{ shrink: true, }}
                                        variant='outlined'
                                        value={round}
                                        onChange={async (e) => { setRound(e.target.value) }}
                                    />
                                </Stack>
                            </Grid>
                            <Grid item xs={6} lg={2}>
                                <Stack>
                                    <TextField
                                        required
                                        fullwidth="true"
                                        size="small"
                                        label={'Year'}
                                        InputLabelProps={{ shrink: true, }}
                                        variant='outlined'
                                        type="number"
                                        value={year}
                                        onChange={async (e) => { setYear(e.target.value) }}
                                    />
                                </Stack>
                                </Grid>
                                <Grid item xs={6} lg={1}>
                                    <Stack>
                                        <TextField
                                            required
                                            fullwidth="true"
                                            size="small"
                                            label={'Month'}
                                            InputLabelProps={{ shrink: true, }}
                                            variant='outlined'
                                            type="number"
                                            InputProps={{ inputProps: { min: 1, max: 12 } }}
                                            value={month}
                                            onChange={async (e) => { setMonth(e.target.value) }}
                                        />
                                    </Stack>
                                </Grid>
                                <Grid item xs={6} lg={1}>
                                    <Stack>
                                        <TextField
                                            required
                                            fullwidth="true"
                                            size="small"
                                            label={'Day'}
                                            InputLabelProps={{ shrink: true, }}
                                            variant='outlined'
                                            type="number"
                                            value={day}
                                            InputProps={{ inputProps: { min: 1, max: 31 } }}
                                            onChange={async (e) => { setDay(e.target.value) }}
                                        />
                                    </Stack>
                                </Grid>
                                <Grid item xs={6} lg={2}>
                                <Stack>
                                    <TextField
                                        required
                                        fullwidth="true"
                                        size="small"
                                        label={'Result'}
                                        InputLabelProps={{ shrink: true, }}
                                        variant='outlined'
                                        value={result}
                                        onChange={async (e) => { setResult(e.target.value) }}
                                    />
                                </Stack>
                            </Grid>
                            <Grid item xs={6} lg={2}>
                                <Stack>
                                    <TextField
                                        required
                                        fullwidth="true"
                                        size="small"
                                        label={'White'}
                                        InputLabelProps={{ shrink: true, }}
                                        variant='outlined'
                                        value={white}
                                        onChange={async (e) => { setWhite(e.target.value) }}
                                    />
                                </Stack>
                            </Grid>
                            <Grid item xs={6} lg={1}>
                                <Stack>
                                    <TextField
                                        required
                                        fullwidth="true"
                                        size="small"
                                        label={'W-Elo'}
                                        InputLabelProps={{ shrink: true, }}
                                        variant='outlined'
                                        value={whiteElo}
                                        onChange={async (e) => { setWhiteElo(e.target.value) }}
                                    />
                                </Stack>
                            </Grid>
                            <Grid item xs={6} lg={1}>
                                <Stack>
                                    <TextField
                                        required
                                        fullwidth="true"
                                        size="small"
                                        label={'W FIDE'}
                                        label={whiteFIDEID > -1 ? <a href={'https://ratings.fide.com/profile/' + whiteFIDEID} target='_blank' rel='noreferrer'>{'FIDE ID' + whiteFIDEID}</a> : 'FIDE ID'}
                                        InputLabelProps={{ shrink: true, }}
                                        variant='outlined'
                                        value={whiteFIDEID}
                                        onChange={async (e) => { setWhiteFIDEID(e.target.value) }}
                                    />
                                </Stack>
                            </Grid>
                            <Grid item xs={6} lg={1}>
                                <Stack>
                                    <TextField
                                        required
                                        fullwidth="true"
                                        size="small"
                                        label={whiteUSCFID > -1 ? <a href={'https://www.uschess.org/msa/MbrDtlTnmtHst.php?' + whiteUSCFID} target='_blank' rel='noreferrer'>{'USCF ID' + whiteUSCFID}</a> : 'USCF ID'}
                                        InputLabelProps={{ shrink: true, }}
                                        variant='outlined'
                                        value={whiteUSCFID}
                                        onChange={async (e) => { setWhiteUSCFID(e.target.value) }}
                                    />
                                </Stack>
                            </Grid>
                            <Grid item xs={6} lg={1}>
                                <Stack>
                                    <TextField
                                        required
                                        fullwidth="true"
                                        size="small"
                                        label={whiteCFCID > -1 ? <a href={'https://www.chess.ca/en/ratings/p/?id=' + whiteCFCID} target='_blank' rel='noreferrer'>{'CFC ID' + whiteCFCID}</a> : 'CFC ID'}
                                        InputLabelProps={{ shrink: true, }}
                                        variant='outlined'
                                        value={whiteCFCID}
                                        onChange={async (e) => { setWhiteCFCID(e.target.value) }}
                                    />
                                </Stack>
                            </Grid>
                            <Grid item xs={6} lg={2}>
                                <Stack>
                                    <TextField
                                        required
                                        fullwidth="true"
                                        size="small"
                                        label={'Black'}
                                        InputLabelProps={{ shrink: true, }}
                                        variant='outlined'
                                        value={black}
                                        onChange={async (e) => { setBlack(e.target.value) }}
                                    />
                                </Stack>
                            </Grid>
                            <Grid item xs={6} lg={1}>
                                <Stack>
                                    <TextField
                                        required
                                        fullwidth="true"
                                        size="small"
                                        label={'B-Elo'}
                                        InputLabelProps={{ shrink: true, }}
                                        variant='outlined'
                                        value={blackElo}
                                        onChange={async (e) => { setBlackElo(e.target.value) }}
                                    />
                                </Stack>
                            </Grid>
                            <Grid item xs={6} lg={1}>
                                <Stack>
                                    <TextField
                                        required
                                        fullwidth="true"
                                        size="small"
                                        label={'W FIDE'}
                                        label={blackFIDEID > -1 ? <a href={'https://ratings.fide.com/profile/' + blackFIDEID} target='_blank' rel='noreferrer'>{'FIDE ID' + blackFIDEID}</a> : 'FIDE ID'}
                                        InputLabelProps={{ shrink: true, }}
                                        variant='outlined'
                                        value={blackFIDEID}
                                        onChange={async (e) => { setBlackFIDEID(e.target.value) }}
                                    />
                                </Stack>
                            </Grid>
                            <Grid item xs={6} lg={1}>
                                <Stack>
                                    <TextField
                                        required
                                        fullwidth="true"
                                        size="small"
                                        label={blackUSCFID > -1 ? <a href={'https://www.uschess.org/msa/MbrDtlTnmtHst.php?' + blackUSCFID} target='_blank' rel='noreferrer'>{'USCF ID' + blackUSCFID}</a> : 'USCF ID'}
                                        InputLabelProps={{ shrink: true, }}
                                        variant='outlined'
                                        value={blackUSCFID}
                                        onChange={async (e) => { setBlackUSCFID(e.target.value) }}
                                    />
                                </Stack>
                            </Grid>
                            <Grid item xs={6} lg={1}>
                                <Stack>
                                    <TextField
                                        required
                                        fullwidth="true"
                                        size="small"
                                        label={blackCFCID > -1 ? <a href={'https://www.chess.ca/en/ratings/p/?id=' + blackCFCID} target='_blank' rel='noreferrer'>{'CFC ID' + blackCFCID}</a> : 'CFC ID'}
                                        InputLabelProps={{ shrink: true, }}
                                        variant='outlined'
                                        value={blackCFCID}
                                        onChange={async (e) => { setBlackCFCID(e.target.value) }}
                                    />
                                </Stack>
                            </Grid>
                            <Grid item xs={6} lg={2}>
                                <Stack>
                                    <TextField
                                        required
                                        fullwidth="true"
                                        size="small"
                                        label={uscfEventId > -1 ? <a href={'https://www.uschess.org/msa/XtblMain.php?' + uscfEventId} target='_blank' rel='noreferrer'>{'USCF Event ' + uscfEventId}</a> : 'USCF Event ID'}
                                        InputLabelProps={{ shrink: true, }}
                                        variant='outlined'
                                        value={uscfEventId}
                                        inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }}
                                        onChange={async (e) => { setUSCFEventId(e.target.value ? e.target.value : -1) }}
                                    />
                                </Stack>
                            </Grid>
                            <Grid item xs={6} lg={2}>
                                <Stack>
                                    <TextField
                                        required
                                        fullwidth="true"
                                        size="small"
                                        label={fideEventId > -1 ? <a href={'https://ratings.fide.com/tournament_information.phtml?event=' + fideEventId} target='_blank' rel='noreferrer'>{'FIDE Event ' + fideEventId}</a> : 'FIDE Event ID'}
                                        InputLabelProps={{ shrink: true, }}
                                        variant='outlined'
                                        value={fideEventId}
                                        inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }}
                                        onChange={async (e) => { setFIDEEventId(e.target.value ? e.target.value : -1) }}
                                    />
                                </Stack>
                            </Grid>
                            {/*<Grid item xs={6} lg={2}>*/}
                            {/*    <Stack>*/}
                            {/*        <TextField*/}
                            {/*            required*/}
                            {/*            fullwidth="true"*/}
                            {/*            size="small"*/}
                            {/*            label={'Membership Level'}*/}
                            {/*            InputLabelProps={{ shrink: true, }}*/}
                            {/*            variant='outlined'*/}
                            {/*            type='number'*/}
                            {/*            InputProps={{ inputProps: { min: 0, max: 9 } }}*/}
                            {/*            value={membershipLevel}*/}
                            {/*            onChange={async (e) => { setMembershipLevel(e.target.value) }}*/}
                            {/*        />*/}
                            {/*    </Stack>*/}
                            {/*</Grid>*/}
                            {/*<Grid item xs={6} lg={2}>*/}
                            {/*    */}{/*<FormControl fullWidth sx={{ m: 1, minWidth: 20 }}>*/}
                            {/*        */}{/*<InputLabel fullWidth id="evnet-serviceLevel-select-helper-label">Access Level</InputLabel>*/}
                            {/*        <Select*/}
                            {/*            labelId="membershipLevel-helper-label"*/}
                            {/*            id="membershipLevel-select"*/}
                            {/*            value={membershipLevel}*/}
                            {/*            label="Access Level66"*/}
                            {/*            size="small"*/}
                            {/*            fullWidth*/}
                            {/*            required*/}
                            {/*            onChange={async (e) => { setMembershipLevel(e.target.value) }}*/}
                            {/*        >*/}
                            {/*            <MenuItem value={'0'}>0 - Basic</MenuItem>*/}
                            {/*            <MenuItem value={'1'}>1 - Bronze</MenuItem>*/}
                            {/*            <MenuItem value={'2'}>2 - Silver</MenuItem>*/}
                            {/*            <MenuItem value={'3'}>3 - Gold</MenuItem>*/}
                            {/*            <MenuItem value={'4'}>4 - Diamond</MenuItem>*/}
                            {/*            <MenuItem value={'9'}>9 - VIP</MenuItem>*/}
                            {/*        </Select>*/}
                            {/*    */}{/*</FormControl>*/}
                            {/*    </Grid>*/}
                                <Grid item xs={6} lg={2}>
                                    <Stack>
                                        <TextField
                                            fullwidth
                                            size="small"
                                            value={membershipLevel}
                                            key={membershipLevel}
                                            defaultValue={membershipLevel}
                                            //defaultValue={'VIP'}
                                            onChange={async (e) => { setMembershipLevel(e.target.value) }}
                                            select
                                            label="Access Level"
                                        >
                                            <MenuItem key={0} value={0}>0 - Basic</MenuItem>
                                            <MenuItem key={1} value={1}>1 - Bronze</MenuItem>
                                            <MenuItem key={2} value={2}>2 - Silver</MenuItem>
                                            <MenuItem key={3} value={3}>3 - Gold</MenuItem>
                                            <MenuItem key={4} value={4}>4 - Diamond</MenuItem>
                                            <MenuItem key={5} value={5}>5 - L5</MenuItem>
                                            <MenuItem key={6} value={6}>6 - L6</MenuItem>
                                            <MenuItem key={7} value={7}>7 - L7</MenuItem>
                                            <MenuItem key={8} value={8}>8 - L8</MenuItem>
                                            <MenuItem key={9} value={9}>9 - VIP</MenuItem>
                                        </TextField>
                                    </Stack>
                                </Grid>
                
                            <Grid item xs={12} lg={6}>
                                <Stack>
                                    <LoadingButton
                                        onClick={async (e) => { await setDownloading(true); await updateChessGame(); }}
                                        loading={downloading}
                                        disabled={!event}
                                        loadingIndicator="Wait"
                                        variant="contained"
                                        color="primary"
                                    >
                                        Update
                                    </LoadingButton>
                                </Stack>
                            </Grid>
                <Grid item xs={12} lg={12}>
                    <Stack>
                        <span style={{ color: statusColor}}>{status}</span>
                    </Stack>
                </Grid>
                        </Grid>
        <Box sx={{ pt: 2, pb: 1 }}>
                <GameById gameId={gameId} displayEditButton={false} key={updateTime} />
            {errorMessage &&
                <div style={{ alignItems: 'center', justifyContent: 'center' }}>
                    <Grid item xs={12} alignItems="center" justifyContent="center" display="flex">
                        <h5 style={{ alignItems: 'center', justifyContent: 'center', color:'red' }}>
                            {errorMessage}
                        </h5>
                    </Grid>
                    <Grid>
                        <SupportUs/>
                    </Grid>
                </div>
            }
            </Box>
        </div>
    )
}

